
import React from 'react';
import { Link } from 'react-router-dom';
import { FaPalette, FaTree, FaUtensils, FaSeedling, FaTheaterMasks, FaBasketballBall, FaWhatsapp } from 'react-icons/fa';

import salidas from '../assets/img/actividades/bomberos.jpeg'
import cocina from '../assets/img/actividades/cocina.jpg'
import arte from '../assets/img/actividades/Arte.png'
import cocina2 from '../assets/img/actividades/Cocina2.png'
import deporte from '../assets/img/actividades/Deporte.png'
import huerta from '../assets/img/actividades/Huerta.png'
import teatro from '../assets/img/actividades/Teatro.png'

const gtag_report_conversion = (url) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-16956303663/FXqBCP_4gNcaEK_SspU_',
      'event_callback': function () {
        if (typeof(url) !== 'undefined') {
          window.location = url;
        }
      }
    });
  } else {
    window.location = url;
  }
};

const Actividades = () => {
  const actividades = [
    {
      id: 1,
      title: "Taller de Arte y Expresión",
      description: "Espacio creativo donde los participantes pueden explorar diferentes técnicas artísticas como pintura, dibujo, collage y modelado. Fomentamos la expresión personal, el desarrollo de la motricidad fina y la coordinación visomotora a través del arte.",
      icon: <FaPalette />,
      image: arte
    },
    {
      id: 2,
      title: "Salidas Recreativas",
      description: "Organizamos salidas a parques, museos, cines y otros espacios culturales y recreativos. Estas actividades promueven la socialización, la integración comunitaria y el aprendizaje en contextos naturales, siempre con el acompañamiento de nuestro equipo profesional.",
      icon: <FaTree />,
      image: salidas
    },
    {
      id: 3,
      title: "Taller de Cocina",
      description: "Actividad que combina aprendizaje práctico con socialización. Los participantes aprenden recetas sencillas, manipulación segura de alimentos y hábitos de alimentación saludable, mientras desarrollan autonomía, trabajo en equipo y habilidades para la vida diaria.",
      icon: <FaUtensils />,
      image: cocina2
    },
    {
      id: 4,
      title: "Huerta Terapéutica",
      description: "Proyecto que permite a los participantes conectar con la naturaleza cultivando plantas y hortalizas. Promueve la responsabilidad, paciencia, trabajo cooperativo y estimulación sensorial, además de enseñar sobre ciclos naturales y alimentación saludable.",
      icon: <FaSeedling />,
      image: huerta
    },
    {
      id: 5,
      title: "Teatro y Expresión Corporal",
      description: "Taller que utiliza el juego dramático y la expresión corporal como herramientas terapéuticas. Fomenta la comunicación verbal y no verbal, la creatividad, la confianza en uno mismo y las habilidades sociales a través de improvisaciones y pequeñas representaciones.",
      icon: <FaTheaterMasks />,
      image: teatro
    },
    {
      id: 6,
      title: "Actividades Deportivas Adaptadas",
      description: "Programa de actividades físicas y deportivas adaptadas a las capacidades de cada participante. Incluye juegos cooperativos, ejercicios de psicomotricidad y deportes modificados que promueven el desarrollo físico, la coordinación y el trabajo en equipo.",
      icon: <FaBasketballBall />,
      image: deporte
    }
  ];

  return (
    <div className="container">
      <div className="sede-header">
        <h1>Actividades Especiales</h1>
        <p>Complementamos nuestros tratamientos con una variedad de actividades especiales, diseñadas para potenciar habilidades y promover la socialización.</p>
      </div>

      <section>
        <p className="text-center" style={{ marginBottom: '40px' }}>
          Nuestras actividades especiales están diseñadas para complementar los tratamientos individuales, 
          ofreciendo espacios de aprendizaje, creatividad y socialización. Estas actividades permiten 
          aplicar y generalizar las habilidades adquiridas en un entorno grupal y lúdico.
        </p>

        <div className="activity-container">
          {actividades.map(actividad => (
            <div key={actividad.id} className="activity-card">
              <div className="activity-image">
                <img src={actividad.image} alt={actividad.title} />
              </div>
              <div className="activity-content">
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                  <div style={{ color: 'var(--accent-color)', fontSize: '1.5rem' }}>
                    {actividad.icon}
                  </div>
                  <h3>{actividad.title}</h3>
                </div>
                <p>{actividad.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="cta-section" style={{ margin: '60px 0', padding: '40px', borderRadius: '10px' }}>
        <div className="cta-content">
          <h2>¿Quieres que tu hijo participe en nuestras actividades?</h2>
          <p>Contáctanos para conocer el cronograma de actividades y cómo tu hijo puede beneficiarse de estas experiencias enriquecedoras.</p>
          <div className="cta-buttons">
            <Link to="/contacto" className="btn">Solicitar información</Link>
            <a href="https://wa.me/5491165651675" className="btn btn-accent">
              <FaWhatsapp /> Contactar por WhatsApp
            </a>
          </div>
        </div>
      </section>

       {/* WhatsApp Float Button With Report*/}
      <a
        href="#"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => {
          e.preventDefault();
          gtag_report_conversion("https://wa.me/5491165651675");
        }}
      >
        <FaWhatsapp />
      </a>
    </div>
  );
};

export default Actividades;
